<script lang="ts">
  import type { ElementSize, FieldState } from '@shared/lib';

  export let state: FieldState = 'default';
  export let label: string | undefined = undefined;
  export let hasClear = false;
  export let onClear: (() => void) | undefined = undefined;
  export let size: ElementSize = 'sm';
</script>

{#if label || hasClear || onClear}
  <div class="mb-3 flex w-full flex-wrap justify-between">
    <!-- svelte-ignore a11y-label-has-associated-control -->
    <label
      class="
				{size === 'sm' ? 'text-sm' : size === 'lg' ? 'text-lg' : 'text-base'}
				font-medium text-inherit {state === 'disabled' ? 'dark:text-dark-700' : 'dark:text-white'}
			"
    >
      {#if label}
        {label}
      {/if}
    </label>
  </div>
{/if}
